var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlCard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 35,
    viewBox: "0 0 26 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7154 13.0997C25.7154 20.1534 19.9374 26.1994 12.8969 26.1994C10.671 26.1994 8.62057 25.6131 6.85714 24.5827V34.2857C3.07005 34.2857 0 31.2157 0 27.4286V1.14286H6.85714V1.68146C8.64327 0.610851 10.7044 0 12.8969 0C20.7359 0 25.7154 6.04601 25.7154 13.0997ZM19.3059 13.0999C19.3059 17.2799 16.3478 20.1536 13.0054 20.1536C9.66312 20.1536 6.9804 16.9956 6.9804 13.0999C6.9804 9.20429 9.1701 6.04625 13.0054 6.04625C16.8408 6.04625 19.3059 8.91997 19.3059 13.0999Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1322_1457",
    x1: 23.7524,
    y1: -5.93407,
    x2: -3.12483,
    y2: -2.89747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#922C32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67122"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlCard1);
export default __webpack_public_path__ + "static/media/pl-card-1.f658ce0187e1ccdb19514645a7dbff50.svg";
export { ForwardRef as ReactComponent };